import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { Reveal, SectionHead } from "@/components/Reveal";
import { FindUs } from "@/components/home/HomeTop";
import { PAGES } from "@/lib/site";
import { CategoryLinks } from "@/components/InlineLinks";

const CRUMBS = [{ name: "Home", path: "/" }, { name: "About", path: "/about" }];

const VALUES = [
  ["Licensed & local", "An ABCA-licensed medical cannabis retailer on 14th Street NW in Logan Circle."],
  ["Guided, not rushed", "Our team can help you pick something out in store — no online order required."],
  ["Order ahead", "Already know what you want? Reserve it online from our live menu before you arrive."],
];

export default function About() {
  return (
    <>
      <Seo {...PAGES.about} path="/about" crumbs={CRUMBS} />
      <PageHeader crumbs={CRUMBS} eyebrow="About District Gaslight" title="A boutique dispensary" highlight="above 14th Street" image="/img/store-3.webp" lead="District Gaslight is a local medical cannabis dispensary in Washington, DC, licensed by the Alcoholic Beverage and Cannabis Administration (ABCA)." />
      <section className="mx-auto grid max-w-7xl items-center gap-12 px-4 py-20 sm:px-6 sm:py-28 lg:grid-cols-2" data-testid="about-story">
        <Reveal className="grid grid-cols-2 gap-4">
          <img src="/img/store-2.webp" alt="Display counters and seating inside District Gaslight" loading="lazy" className="col-span-2 aspect-[16/10] w-full rounded-2xl object-cover" />
          <img src="/img/store-6.webp" alt="Lit display case beside the brick wall inside District Gaslight" loading="lazy" className="aspect-[4/5] w-full rounded-2xl object-cover" />
          <img src="/img/store-5.webp" alt="Shelves of rolling papers and accessories" loading="lazy" className="aspect-[4/5] w-full rounded-2xl object-cover" />
        </Reveal>
        <Reveal delay={0.1}>
          <SectionHead eyebrow="Our approach" title="Help first. Then the right product.">
            <p className="mt-5 text-base leading-relaxed text-neutral-600">
              After we help you discover what you want, we work with you to find the best way of getting there. Our shelves cover <CategoryLinks />, and our <Link to="/shop-all" className="font-semibold underline underline-offset-4">online menu</Link> shows exactly what's in stock today.
            </p>
            <p className="mt-4 text-base leading-relaxed text-neutral-600">
              Shopping with us requires a valid 21+ ID and a medical cannabis patient registration. DC residents can <Link to="/medical-card" className="font-bold underline underline-offset-4">self-certify online</Link>, and visitors
              can use ABCA's non-DC form or a valid card from home.
            </p>
          </SectionHead>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/shop-all" className="btn-lime" data-testid="about-shop-button">Shop now</Link>
            <Link to="/location" className="btn-outline" data-testid="about-location-button">Hours &amp; map</Link>
          </div>
        </Reveal>
      </section>
      <section className="border-t border-neutral-200 bg-white py-20" aria-labelledby="values-title">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <h2 id="values-title" className="h-section">What to expect</h2>
          <ul className="mt-10 grid gap-4 md:grid-cols-3">
            {VALUES.map(([t, d], i) => (
              <Reveal as="li" key={t} delay={i * 0.06} className="border border-neutral-200 p-8">
                <span className="font-display text-4xl font-black text-brand-lime [-webkit-text-stroke:1px_#121212]">0{i + 1}</span>
                <h3 className="mt-4 font-display text-lg font-bold">{t}</h3>
                <p className="mt-2 text-sm leading-relaxed text-neutral-500">{d}</p>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>
      <FindUs />
    </>
  );
}
